import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalSelectedDocuments: number
  loading: boolean
  onSubmit: () => void
  onClose: () => void
  useF0?: boolean
}

const HideModal = ({
  totalSelectedDocuments,
  loading,
  onSubmit,
  onClose,
  useF0 = false,
}: Props) => {
  if (useF0) {
    return (
      <F0Dialog
        isOpen
        width="sm"
        title={i18n.t('documents.employee.bulk-actions.hide-dialog.title', {
          count: totalSelectedDocuments,
        })}
        onClose={onClose}
        primaryAction={{
          label: i18n.t('documents.employee.bulk-actions.hide-dialog.submit'),
          onClick: onSubmit,
          loading,
        }}
      >
        <F0Box display="flex" flexDirection="column" gap="xl">
          <F0Text
            variant="body"
            content={i18n.t('documents.employee.bulk-actions.hide-dialog.description')}
          />
        </F0Box>
      </F0Dialog>
    )
  }

  return (
    <Modal
      illustration="visibility"
      title={i18n.t('documents.employee.bulk-actions.hide-dialog.title', {
        count: totalSelectedDocuments,
      })}
      description={i18n.t('documents.employee.bulk-actions.hide-dialog.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button submit loading={loading}>
          {i18n.t('documents.employee.bulk-actions.hide-dialog.submit')}
        </Button>
      }
    />
  )
}

export default HideModal
